<div class="loader-container">
  <mat-spinner [diameter]="size" color="primary"></mat-spinner>
</div>
